import * as React from "react"

type State = { hasError: boolean; error?: any }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: any, info: any) {
    try {
      // Simple logging; could integrate with telemetry
      console.error("ErrorBoundary caught:", error, info)
    } catch { }
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="px-6 py-10">
          <div role="alert" className="max-w-3xl mx-auto bg-red-50 border border-red-200 text-red-800 rounded-md p-6">
            <h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
            <p className="mb-4">Please refresh the page. If the problem persists, try switching language or navigating back to the dashboard.</p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="mt-4 p-4 bg-red-100 rounded text-xs overflow-auto">
                {this.state.error.toString()}
              </pre>
            )}
            <button className="mt-4 px-3 py-1 bg-red-100 rounded hover:bg-red-200 transition-colors" onClick={() => this.setState({ hasError: false, error: undefined })}>Dismiss</button>
          </div>
        </main>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
